/* eslint-disable arrow-parens */
/* eslint-disable comma-dangle */
/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable no-multi-assign */
/* eslint-disable no-unused-expressions */
import { Swiper as UpdatedSwiper } from 'swiper/bundle';
import DOMReady from '../utils/DomReady';
import { validateForm } from '../utils/ValidateForm';
import Tracking, { getQueryParameter } from "../utils/Tracking";
import { renderRecaptcha, executeRecaptcha } from "../utils/Recaptcha";

DOMReady(() => {
  // With this variable we check if is a Professional, so we can manage some logic with this.
  const isProfessionalPresent = document.getElementById('expert-profile-present');
  const sbsContainer = document.querySelector('.sbs__container');
  const logoDesktop = document.querySelector('.sbs__logo--desktop')

  const recaptchaCallbackByStep = token => {
    let request = {
      name: document.querySelector('#verification_request_name').value,
      email: document.querySelector('#verification_request_email').value
    }

    if (isProfessionalPresent) {
      request = {
        ...request,
        request_type: "existent_company",
        expert_profile_id: document.querySelector('#verification_request_expert_profile_id').value
      }
    } else {
      const inputs = document.querySelectorAll('.js-sbs-credit-missing')
      const values = [];
      inputs && inputs.forEach(el => {
        el.value !== "" && (values.push(el.value))
      })

      request = {
        ...request,
        request_type: "non_existent_company",
        telephone: document.querySelector('#verification_request_telephone').value,
        request_message: values.join(", "),
        company_name: document.querySelector('#verification_request_company_name').value
      }
    }

    processRequest(`/professionals/${AD.site}/verification_requests`, JSON.stringify({
      verification_request: request,
      'g-recaptcha-response': token
    }), (response) => {
      if (isProfessionalPresent) {
        // we set an input hidden with the verification request id,
        hiddenInput(swiperContainer, response)
        objectResponse = response;
      }

      sbsContainer.classList.add('sbs__container--thanks')
      logoDesktop.classList.add('sbs__logo--hidden');
      sbsJoin.slideNext();
      const stage = sbsJoin.slides[sbsJoin.activeIndex].dataset.stage;
      trackStage(stage, { category: "pro-sbs", action: "arrive" });
    }, (error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    })
  }

  const swiperProperties = {
    spaceBetween: 77,
    preventInteractionOnTransition: true,
    allowTouchMove: false,
    navigation: {
      prevEl: '.js-swiper-prev-btn',
    },
    on: {
      init() {
        // Initializing ReCaptcha
        renderRecaptcha(document.getElementById('invisible-recaptcha'), recaptchaCallbackByStep)

        // We send initial event and pageview.
        const stage = this.slides[this.activeIndex].dataset.stage;
        trackStage(stage, { category: "pro-sbs", action: "arrive" });

        document.querySelectorAll('.sbs__next-btn').forEach(el => {
          el.addEventListener('click', onSwiperForward);
        });

        document.querySelectorAll('.js-swiper-prev-btn').forEach(el => {
          el.addEventListener('click', onSwiperBack);
        });

        // fix bug when pressing TAB key on keyboard
        const noTabInputs = document.querySelectorAll('.no-tab-input');
        noTabInputs && noTabInputs.forEach(input => input.addEventListener('keydown', e => e.keyCode === 9 && e.preventDefault()));
      }
    }
  };

  // Start step by step Swiper
  const swiperContainer = document.querySelector('#sbs__sign-up');
  let objectResponse = {};

  // Ajax call to process step by step forms
  const processRequest = (url, body, successCallback = null, errorCallback = null, options = {}) => {
    const method = options.method || 'POST';
    fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.head.querySelector("[name='csrf-token']").content,
      },
      body,
    })
      .then((resp) => resp.json().then((data) => ({ status: resp.status, body: data })))
      .then((resp) => {
        if (resp.status >= 400) {
          errorCallback(resp);
        } else if (successCallback) successCallback(resp.body);
      })
      .catch((error) => {
        if (errorCallback) errorCallback(error);
      });
  };

  const hiddenInput = (swiperContainer, response) => {
    const inputId = document.createElement('input')
    inputId.setAttribute('type', 'hidden')
    inputId.setAttribute('name', 'verification_request[id]')
    inputId.setAttribute('value', response.id)
    inputId.id = 'verification_request_id'
    swiperContainer.appendChild(inputId)
  }

  const trackStage = (stage, eventData) => {
    const adSource = getQueryParameter("ad_source");
    const pathname = adSource !== null ? `${location.pathname}/${stage}?ad_source=${adSource}` : `${location.pathname}/${stage}`;
    Tracking.setPage(pathname);
    Tracking.pageview({ url: pathname });
    Tracking.event({ category: eventData.category, action: eventData.action, label: stage });
  }


  const onSwiperForward = evt => {
    if (evt.target.classList.contains('afd-btn--not-allowed')) return;
    if ((isProfessionalPresent && sbsJoin.activeIndex === 1) || sbsJoin.activeIndex === 3) {
      executeRecaptcha()
    } else {
      sbsJoin.slideNext();
      // tracking
      const stage = sbsJoin.slides[sbsJoin.activeIndex].dataset.stage;
      trackStage(stage, { category: "pro-sbs", action: "arrive" });
    }
  }

  const onSwiperBack = () => {
    if (window.ga && ga.loaded) {
      const prevStage = sbsJoin.slides[sbsJoin.activeIndex - 1].dataset.stage;
      const stage = sbsJoin.slides[sbsJoin.activeIndex].dataset.stage;
      trackStage(prevStage, { category: "pro-sbs", action: "leave" });
    }
  };

  let sbsJoin = new UpdatedSwiper(swiperContainer, swiperProperties);

  //validate steps forms when professionals is present
  if (isProfessionalPresent) {
    validateForm(
      document.querySelector('.verification_request_step_1'),
      {
        validations: {
          '#verification_request_name': 'required',
          '#verification_request_email': 'email',
          '#js-accept-terms': 'checkbox'
        },
        cta: '#verification_request_step_1_cta'
      }
    );
  } else {
    validateForm(
      document.querySelector('.verification_request_step_2_no_verified'),
      {
        validations: {
          '#verification_request_name': 'required',
          '#verification_request_company_name': 'required',
          '#js-accept-terms-nolist': 'checkbox'
        },
        cta: '#verification_request_step_2_no_verified_cta',
      }
    );

    //For Step 3: for demo
    validateForm(
      document.querySelector('.verification_request_step_3_no_verified'),
      {
        validations: {
          '#verification_request_email': 'email',
          '#verification_request_telephone': 'phone'
        },
        cta: '#verification_request_step_3_no_verified_cta',
      }
    );

    //For Step 4: for demo
    validateForm(
      document.querySelector('.verification_request_step_4_no_verified'),
      {
        validations: {
          '#verification_request_link': 'link',
          '#verification_request_role': 'required',
          '#verification_request_confirm_company_name': 'required'
        },
        cta: '#verification_request_step_4_no_verified_cta',
      }
    )
  }

  const backRedirect = () => {
    const goBackBtn = document.querySelector('.js-go-back');
    goBackBtn && goBackBtn.addEventListener('click', () => {
      if (document.referrer !== "") {
        window.location.href = document.referrer
      } else if (window.history?.length) {
        window.history.back();
      }
    });
  }

  backRedirect();
});

